export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cc0e965add713bc3c44ae8520fdf9a0c.jpg"
          alt="Health Insurance Protection in Kerrville Texas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Location Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#0077B6]/80 backdrop-blur-sm rounded-full mb-8">
          <i className="ri-map-pin-line text-white text-sm"></i>
          <span className="text-white text-sm font-medium">Serving Kerrville & Kerr County, Texas</span>
        </div>

        {/* Main Headline */}
        <h2
          className="text-6xl md:text-7xl font-bold text-white mb-6 leading-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Your Health Insurance
          <br />
          <span className="text-5xl md:text-6xl">Experts in Kerrville, TX</span>
        </h2>

        {/* Subtitle */}
        <p className="text-lg text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
          Comprehensive health insurance solutions for individuals, families, and businesses in Kerr County. 
          From private health insurance to Medicare and group plans, we make healthcare coverage simple and affordable.
        </p>

        {/* CTA Buttons */}
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <a
            href="#contact"
            className="px-8 py-4 bg-[#0077B6] text-white text-base font-semibold rounded-lg hover:bg-[#005F8C] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get a Free Quote
          </a>
          <a
            href="tel:830-203-6201"
            className="px-8 py-4 bg-white text-[#0077B6] text-base font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer border-2 border-white"
          >
            Call 830-203-6201
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
